import React from 'react';

export const TaskBulkActionsBar = ({
    selectedCount,
    onBulkStatusChange,
    onClearSelection,
}) => {
    if (!selectedCount) {
        return null;
    }

    return (
        <div className="d-flex flex-wrap justify-content-between align-items-center gap-2 mb-2 p-2 border rounded bg-light">
            <div className="fw-semibold">{selectedCount} ticket(s) seleccionados</div>
            <div className="d-flex gap-2">
                <button type="button" className="btn btn-primary btn-sm" onClick={onBulkStatusChange}>
                    Cambio masivo de estatus
                </button>
                <button type="button" className="btn btn-light-brand btn-sm" onClick={onClearSelection}>
                    Limpiar selección
                </button>
            </div>
        </div>
    );
};
